import { render, staticRenderFns } from "./RechercheArticles.vue?vue&type=template&id=10609be4&"
import script from "./RechercheArticles.vue?vue&type=script&lang=js&"
export * from "./RechercheArticles.vue?vue&type=script&lang=js&"
import style0 from "./RechercheArticles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10609be4')) {
      api.createRecord('10609be4', component.options)
    } else {
      api.reload('10609be4', component.options)
    }
    module.hot.accept("./RechercheArticles.vue?vue&type=template&id=10609be4&", function () {
      api.rerender('10609be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/RechercheArticles.vue"
export default component.exports